export interface ServiceCategory {
  title: string;
  icon: string;
  items: { label: string; href: string }[];
}

export interface IndustryItem {
  name: string;
  desc: string;
  icon: string;
  href: string;
}

export interface SolutionGroup {
  title: string;
  icon: string;
  items: { label: string; href: string }[];
}

export interface TechGroup {
  name: string;
  items: { name: string; logo?: string; featured?: boolean }[];
}

export const servicesMegaMenuData: ServiceCategory[] = [
  {
    title: "Laravel & Backend Development",
    icon: "ri-code-s-slash-line",
    items: [
      { label: "Laravel Development", href: "/services/laravel-development" },
      { label: "Custom Laravel Development", href: "/services/laravel-development" },
      { label: "Laravel API Development", href: "/services/laravel-development" },
      { label: "Laravel SaaS Development", href: "/services/laravel-development" },
      { label: "Laravel Enterprise Applications", href: "/services/laravel-development" },
      { label: "Laravel Migration", href: "/services/laravel-development" },
      { label: "Laravel Performance Optimization", href: "/services/laravel-development" },
      { label: "Laravel Maintenance & Support", href: "/services/laravel-development" },
      { label: "Hire Laravel Developers", href: "/hire-laravel-developer" },
    ],
  },
  {
    title: "Web Development",
    icon: "ri-window-line",
    items: [
      { label: "Custom Web Application Development", href: "/services/web-development" },
      { label: "PHP Development", href: "/services/web-development" },
      { label: "Vue.js Development", href: "/services/web-development" },
      { label: "React Development", href: "/services/web-development" },
      { label: "Admin Panel Development", href: "/services/web-development" },
      { label: "CRM Development", href: "/services/web-development" },
      { label: "ERP Development", href: "/services/web-development" },
      { label: "Enterprise Web Applications", href: "/services/web-development" },
    ],
  },
  {
    title: "Mobile App Development",
    icon: "ri-smartphone-line",
    items: [
      { label: "Flutter App Development", href: "/services/mobile-app-development" },
      { label: "Android App Development", href: "/services/mobile-app-development" },
      { label: "iOS App Development", href: "/services/mobile-app-development" },
      { label: "Cross-Platform App Development", href: "/services/mobile-app-development" },
      { label: "Mobile API Development", href: "/services/api-development" },
      { label: "Push Notification Integration", href: "/services/mobile-app-development" },
    ],
  },
  {
    title: "AI & AI Development",
    icon: "ri-bard-line",
    items: [
      { label: "AI Integration", href: "/services/ai-development" },
      { label: "AI-Powered Applications", href: "/services/ai-development" },
      { label: "ChatGPT Integration", href: "/services/ai-development" },
      { label: "Claude Integration", href: "/services/ai-development" },
      { label: "AI Chatbots", href: "/services/ai-development" },
      { label: "AI Assistants", href: "/services/ai-development" },
      { label: "AI Workflow Automation", href: "/services/ai-development" },
      { label: "AI API Integration", href: "/services/ai-development" },
      { label: "AI-powered SaaS", href: "/services/ai-development" },
    ],
  },
  {
    title: "API & SaaS Development",
    icon: "ri-exchange-line",
    items: [
      { label: "REST API Development", href: "/services/api-development" },
      { label: "Third-party API Integration", href: "/services/api-development" },
      { label: "Payment API Integration", href: "/services/api-development" },
      { label: "SaaS Development", href: "/services/saas-development" },
      { label: "Multi-Tenant Applications", href: "/services/saas-development" },
      { label: "Subscription Platforms", href: "/services/saas-development" },
      { label: "Microservices", href: "/services/api-development" },
    ],
  },
  {
    title: "Cloud & DevOps",
    icon: "ri-server-line",
    items: [
      { label: "AWS", href: "/services/cloud-devops" },
      { label: "Cloud Deployment", href: "/services/cloud-devops" },
      { label: "Docker", href: "/services/cloud-devops" },
      { label: "CI/CD", href: "/services/cloud-devops" },
      { label: "Cloudflare", href: "/services/cloud-devops" },
      { label: "Server Setup", href: "/services/cloud-devops" },
      { label: "Monitoring", href: "/services/cloud-devops" },
      { label: "Performance Optimization", href: "/services/cloud-devops" },
      { label: "Security", href: "/services/cloud-devops" },
    ],
  },
  {
    title: "UI/UX & Product Design",
    icon: "ri-palette-line",
    items: [
      { label: "UI/UX Design", href: "/services/ui-ux-design" },
      { label: "Web Design", href: "/services/ui-ux-design" },
      { label: "Mobile App UI/UX", href: "/services/ui-ux-design" },
      { label: "Dashboard Design", href: "/services/ui-ux-design" },
      { label: "SaaS Product Design", href: "/services/ui-ux-design" },
      { label: "Design Systems", href: "/services/ui-ux-design" },
    ],
  },
  {
    title: "Maintenance & Support",
    icon: "ri-tools-line",
    items: [
      { label: "Application Maintenance", href: "/services/maintenance-support" },
      { label: "Bug Fixing", href: "/services/maintenance-support" },
      { label: "Performance Optimization", href: "/services/maintenance-support" },
      { label: "Security Updates", href: "/services/maintenance-support" },
      { label: "Server Maintenance", href: "/services/maintenance-support" },
      { label: "Long-Term Technical Support", href: "/services/maintenance-support" },
    ],
  },
];

export const industriesMegaMenuData: {
  items: IndustryItem[];
  highlight: {
    title: string;
    desc: string;
    stats: { value: string; label: string }[];
    cta: string;
    ctaHref: string;
    image: string;
  };
} = {
  items: [
    { name: "Healthcare", desc: "Digital solutions for modern healthcare businesses.", icon: "ri-hospital-line", href: "/industries/healthcare" },
    { name: "FinTech", desc: "Secure and scalable financial technology solutions.", icon: "ri-bank-line", href: "/industries/fintech" },
    { name: "E-commerce", desc: "High-performance commerce experiences.", icon: "ri-shopping-bag-2-line", href: "/industries/ecommerce" },
    { name: "Education", desc: "Smart learning platforms and digital engagement tools.", icon: "ri-graduation-cap-line", href: "/industries/education" },
    { name: "Real Estate", desc: "Property tech solutions and intelligent market analytics.", icon: "ri-building-line", href: "/industries/real-estate" },
    { name: "Logistics", desc: "AI-driven route optimization and supply chain tracking.", icon: "ri-truck-line", href: "/industries/logistics" },
    { name: "Travel", desc: "Intelligent booking systems and personalized experiences.", icon: "ri-plane-line", href: "/industries/travel" },
    { name: "SaaS", desc: "Scalable software products built for growth.", icon: "ri-cloud-line", href: "/industries/saas" },
    { name: "Enterprise", desc: "AI workflow automation and business intelligence.", icon: "ri-building-4-line", href: "/industries/enterprise" },
    { name: "Media & Entertainment", desc: "AI content generation and streaming platforms.", icon: "ri-movie-line", href: "/industries/media-entertainment" },
  ],
  highlight: {
    title: "Technology Solutions Across Industries",
    desc: "We build scalable digital products tailored to the unique needs of modern businesses.",
    stats: [
      { value: "100+", label: "Projects" },
      { value: "50+", label: "Clients" },
      { value: "10+", label: "Years Experience" },
    ],
    cta: "Explore All Industries",
    ctaHref: "/industries",
    image: "https://readdy.ai/api/search-image?query=Abstract%203D%20technology%20visualization%20with%20blue%20and%20purple%20gradient%20glow%2C%20floating%20geometric%20shapes%2C%20digital%20particles%2C%20premium%20tech%20aesthetic%2C%20dark%20background%2C%20no%20text&width=400&height=320&seq=astrojal-ind-highlight&orientation=landscape",
  },
};

export const solutionsMegaMenuData: SolutionGroup[] = [
  {
    title: "For Startups",
    icon: "ri-rocket-line",
    items: [
      { label: "MVP Development", href: "/solutions" },
      { label: "Startup Product Development", href: "/solutions" },
      { label: "Dedicated Developers", href: "/hire-laravel-developer" },
      { label: "SaaS Development", href: "/services/saas-development" },
    ],
  },
  {
    title: "For Businesses",
    icon: "ri-building-4-line",
    items: [
      { label: "Custom Software", href: "/solutions" },
      { label: "Business Automation", href: "/solutions" },
      { label: "CRM & ERP", href: "/services/web-development" },
      { label: "Enterprise Applications", href: "/solutions" },
    ],
  },
  {
    title: "For Enterprises",
    icon: "ri-bar-chart-box-line",
    items: [
      { label: "Enterprise Software", href: "/solutions" },
      { label: "API Ecosystems", href: "/services/api-development" },
      { label: "Cloud Modernization", href: "/services/cloud-devops" },
      { label: "Legacy Application Modernization", href: "/solutions" },
    ],
  },
  {
    title: "For Product Companies",
    icon: "ri-box-3-line",
    items: [
      { label: "SaaS Development", href: "/services/saas-development" },
      { label: "Product Engineering", href: "/solutions" },
      { label: "Dedicated Development Teams", href: "/hire-laravel-developer" },
      { label: "Technical Support", href: "#" },
    ],
  },
  {
    title: "AI Solutions",
    icon: "ri-bard-line",
    items: [
      { label: "AI Integration", href: "/services/ai-development" },
      { label: "AI Chatbots", href: "/services/ai-development" },
      { label: "AI Assistants", href: "/services/ai-development" },
      { label: "AI Workflow Automation", href: "/services/ai-development" },
      { label: "AI-powered Applications", href: "/ai-solutions" },
    ],
  },
];

export const technologiesMegaMenuData: TechGroup[] = [
  {
    name: "Backend",
    items: [
      { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", featured: true },
      { name: "PHP", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg" },
      { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg" },
    ],
  },
  {
    name: "Frontend",
    items: [
      { name: "Vue.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/vuejs/vuejs-original.svg" },
      { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" },
      { name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg" },
      { name: "Tailwind CSS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg" },
      { name: "HTML5", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg" },
      { name: "CSS3", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg" },
    ],
  },
  {
    name: "Mobile",
    items: [
      { name: "Flutter", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg" },
      { name: "Dart", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dart/dart-original.svg" },
    ],
  },
  {
    name: "Database",
    items: [
      { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original.svg" },
      { name: "PostgreSQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original.svg" },
      { name: "Redis", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg" },
    ],
  },
  {
    name: "DevOps",
    items: [
      { name: "Docker", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/docker/docker-original.svg" },
      { name: "Git", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-original.svg" },
      { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg" },
      { name: "CI/CD", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/githubactions/githubactions-original.svg" },
    ],
  },
  {
    name: "Cloud",
    items: [
      { name: "AWS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" },
      { name: "Cloudflare", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/cloudflare/cloudflare-original.svg" },
      { name: "DigitalOcean", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/digitalocean/digitalocean-original.svg" },
    ],
  },
  {
    name: "Tools & Others",
    items: [
      { name: "Postman", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg" },
      { name: "Figma", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/figma/figma-original.svg" },
      { name: "Nginx", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nginx/nginx-original.svg" },
      { name: "Jira", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg" },
      { name: "Slack", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/slack/slack-original.svg" },
      { name: "Trello", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/trello/trello-original.svg" },
    ],
  },
  {
    name: "AI & AI Development",
    items: [
      { name: "ChatGPT", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/openai.svg" },
      { name: "Claude", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/claude-color.svg" },
      { name: "Claude Code", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/claude-color.svg" },
      { name: "GitHub Copilot", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/githubcopilot.svg" },
      { name: "Gemini", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/gemini-color.svg" },
      { name: "Cursor", logo: "https://www.cursor.com/assets/images/logo.svg" },
      { name: "OpenAI Codex", logo: "https://registry.npmmirror.com/@lobehub/icons-static-svg/latest/files/icons/codex-color.svg" },
    ],
  },
];

export const contactDropdownData = {
  items: [
    { label: "Start a Project", href: "/contact-us" },
    { label: "Hire Laravel Developer", href: "/hire-laravel-developer" },
    { label: "Request a Consultation", href: "/contact-us" },
    { label: "Contact Us", href: "/contact-us" },
  ],
};

export interface CompanyMenuItem {
  label: string;
  desc: string;
  icon: string;
  href: string;
}

export const companyDropdownData: { items: CompanyMenuItem[] } = {
  items: [
    { label: "About Us", desc: "Our story, mission and values", icon: "ri-information-line", href: "/about-us" },
    { label: "Our Team", desc: "Meet the people behind AstroJal", icon: "ri-team-line", href: "/our-team" },
    { label: "Life at AstroJal", desc: "Culture, growth and our way of working", icon: "ri-heart-3-line", href: "/life-at-astrojal" },
    { label: "Careers", desc: "Open roles and how to apply", icon: "ri-briefcase-line", href: "/careers" },
    { label: "Holiday List", desc: "Company holidays for the year", icon: "ri-calendar-event-line", href: "/holiday-list" },
    { label: "Contact Us", desc: "Get in touch with our team", icon: "ri-customer-service-2-line", href: "/contact-us" },
  ],
};

export const companyReviewsData = {
  platforms: [
    { name: "Glassdoor", rating: 4.9, logo: "https://cdn.simpleicons.org/glassdoor/0CAA41" },
    { name: "Google", rating: 5.0, logo: "https://cdn.simpleicons.org/google" },
    { name: "GoodFirms", rating: 5.0, logo: "https://www.google.com/s2/favicons?domain=goodfirms.co&sz=128" },
    { name: "Upwork", rating: 5.0, logo: "https://cdn.simpleicons.org/upwork/14A800" },
    { name: "AmbitionBox", rating: 4.8, logo: "https://www.google.com/s2/favicons?domain=ambitionbox.com&sz=128" },
    { name: "Clutch", rating: 4.9, logo: "https://www.google.com/s2/favicons?domain=clutch.co&sz=128" },
  ],
};

export const portfolioDropdownData = {
  items: [
    { label: "All Projects", href: "/portfolio" },
    { label: "Laravel Projects", href: "/portfolio?category=laravel" },
    { label: "SaaS Projects", href: "/portfolio?category=saas" },
    { label: "Web Applications", href: "/portfolio?category=web" },
    { label: "Mobile Apps", href: "/portfolio?category=mobile" },
    { label: "API Projects", href: "/portfolio?category=api" },
    { label: "AI Projects", href: "/portfolio?category=ai" },
    { label: "Enterprise Solutions", href: "/portfolio?category=enterprise" },
  ],
};

export const mainNavLinks = [
  { label: "Home", href: "/", hasMega: false },
  { label: "Services", href: "/services", hasMega: true, megaType: "services" as const },
  { label: "Industries", href: "/industries", hasMega: true, megaType: "industries" as const },
  { label: "Solutions", href: "/solutions", hasMega: true, megaType: "solutions" as const },
  { label: "Technologies", href: "/technologies", hasMega: true, megaType: "technologies" as const },
  { label: "Company", href: "/about-us", hasMega: true, megaType: "company" as const },
  { label: "Portfolio", href: "/portfolio", hasMega: true, megaType: "portfolio" as const },
  { label: "Contact Us", href: "/contact-us", hasMega: false, hasDropdown: true },
  { label: "Blog", href: "/blog", hasMega: false },
];